if (!window.CustomOptionLoaded) {
  window.CustomOptionLoaded = true;

(function () {
  'use strict';

  var updateTimer = null;
  var isProgrammaticClear = false;
  var forceShowTimer = null;

  function qsa(root, selector) {
    try {
      return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    } catch (e) {
      return [];
    }
  }

  function closest(el, selector) {
    if (!el || !el.closest) return null;
    try {
      return el.closest(selector);
    } catch (e) {
      return null;
    }
  }

  function addUnique(list, item) {
    if (item && list.indexOf(item) === -1) list.push(item);
  }

  function sanitizeCustomDimensionValue(value) {
    var sanitized = String(value || '').replace(/[^0-9.]/g, '');
    var parts = sanitized.split('.');

    if (parts.length > 1) {
      sanitized = parts.shift() + '.' + parts.join('');
    }

    return sanitized;
  }

  function isValidCustomDimensionValue(value) {
    return /^\d+(?:\.\d+)?$/.test(String(value || '').trim());
  }

  function sanitizeCustomDimensionInput(input) {
    var sanitized = sanitizeCustomDimensionValue(input.value);

    if (input.value !== sanitized) {
      input.value = sanitized;
    }
  }

  function ensureStyle() {
    if (document.getElementById('custom-dimensions-atc-fix-style')) return;

    var style = document.createElement('style');
    style.id = 'custom-dimensions-atc-fix-style';
    style.textContent = '.is-custom-value-add-hidden{display:none!important;}';
    document.head.appendChild(style);
  }

  function isInsideCustomDimensionTextArea(el) {
    return !!closest(
      el,
      '.custom-dimensions-picker__customize, ' +
        '.custom-dimensions-picker__customize-fields, ' +
        '[data-store-only-property="true"], ' +
        '[data-custom-dimension-field], ' +
        '[data-custom-dimensions-customize], ' +
        '[data-custom-dimensions-custom-input]'
    );
  }

  function isInsideQuoteArea(el) {
    return !!closest(
      el,
      '.block-addon-group--quote, ' +
        '[data-custom-modification-options], ' +
        '[data-option-group="quote-only"]'
    );
  }

  function isQuoteCustomControl(control) {
    if (!control) return false;

    if (control.getAttribute('data-custom-dimension-radio') === 'true') return false;

    if (control.getAttribute('data-quote-only') === 'true') return true;
    if (isInsideQuoteArea(control)) return true;

    if (
      control.getAttribute('data-is-custom-option') === 'true' &&
      !closest(control, '.custom-dimensions-picker')
    ) {
      return true;
    }

    return false;
  }

  function hasQuoteCustomSelected() {
    return qsa(
      document,
      '.block-addon-group--quote input[type="radio"]:checked, ' +
        '.block-addon-group--quote input[type="checkbox"]:checked, ' +
        '[data-custom-modification-options] input[type="radio"]:checked, ' +
        '[data-custom-modification-options] input[type="checkbox"]:checked, ' +
        '[data-option-group="quote-only"] input[type="radio"]:checked, ' +
        '[data-option-group="quote-only"] input[type="checkbox"]:checked, ' +
        'input[data-quote-only="true"]:checked, ' +
        'input[data-is-custom-option="true"]:checked'
    ).some(function (input) {
      return isQuoteCustomControl(input);
    });
  }

  function hasCustomDimensionSelected() {
    return qsa(document, '[data-custom-dimension-radio="true"]:checked').length > 0;
  }

  function getCustomDimensionFields(root) {
    var fields = [];

    qsa(
      root || document,
      '[data-store-only-property="true"], ' +
        '[data-custom-dimension-field], ' +
        '[data-custom-dimensions-custom-input] input, ' +
        '[data-custom-dimensions-custom-input] textarea, ' +
        '[data-custom-dimensions-custom-input] select, ' +
        '.custom-dimensions-picker__customize-fields input, ' +
        '.custom-dimensions-picker__customize-fields textarea, ' +
        '.custom-dimensions-picker__customize-fields select'
    ).forEach(function (field) {
      if (!field) return;

      var type = (field.getAttribute('type') || '').toLowerCase();

      if (type === 'button' || type === 'submit' || type === 'reset' || type === 'image' || type === 'file') {
        return;
      }

      if ((type === 'radio' || type === 'checkbox') && field.getAttribute('data-custom-dimension-radio') !== 'true') {
        return;
      }

      addUnique(fields, field);
    });

    return fields;
  }

  function getFieldValue(field) {
    if (!field) return '';

    if (field.tagName === 'SELECT') return String(field.value || '').trim();

    var type = (field.getAttribute('type') || '').toLowerCase();

    if (type === 'radio' || type === 'checkbox') {
      return field.checked ? String(field.value || '').trim() : '';
    }

    sanitizeCustomDimensionInput(field);

    return String(field.value || '').trim();
  }

  function hasCustomDimensionFieldValue() {
    return getCustomDimensionFields(document).some(function (field) {
      var type = (field.getAttribute('type') || '').toLowerCase();

      if (type === 'radio' || type === 'checkbox') {
        return false;
      }

      return getFieldValue(field) !== '';
    });
  }

  function shouldHideAddToCart() {
    return hasQuoteCustomSelected() || hasCustomDimensionSelected() || hasCustomDimensionFieldValue();
  }

  function getAddToCartButtons() {
    var buttons = [];

    qsa(
      document,
      '[data-custom-atc-button], ' +
        '[data-add-to-cart], ' +
        '[data-atc-button], ' +
        '[data-product-submit], ' +
        '.product-form__submit, ' +
        '.product-form__cart-submit, ' +
        '.button--add-to-cart, ' +
        '.add-to-cart, ' +
        'button[name="add"], ' +
        'input[name="add"], ' +
        'form[action*="/cart/add"] button[type="submit"], ' +
        'form[action*="/cart/add"] input[type="submit"], ' +
        '[id^="x-atc-button-"], ' +
        '[id*="x-atc-button"]'
    ).forEach(function (button) {
      if (!button) return;
      if (isInsideCustomDimensionTextArea(button)) return;

      var text = String(button.textContent || button.value || '').toLowerCase();

      if (text.indexOf('quote') !== -1) return;
      if (button.matches && button.matches('[data-shopify="payment-button"], .shopify-payment-button button')) return;

      addUnique(buttons, button);
    });

    return buttons;
  }

  function getPickerFieldMap(picker) {
    var map = {};

    getCustomDimensionFields(picker).forEach(function (field) {
      var key = String(field.getAttribute('data-custom-dimension-field') || '').toLowerCase();

      if (key) {
        map[key] = field;
      }
    });

    return map;
  }

  function getPickerCustomState(picker) {
    var fields = getPickerFieldMap(picker);
    var fieldKeys = Object.keys(fields);
    var hasAnyValue = fieldKeys.some(function (key) {
      return !!getFieldValue(fields[key]);
    });
    var hasCustomRadio = qsa(picker, '[data-custom-dimension-radio="true"]:checked').length > 0;
    var missing = [];
    var invalid = [];

    fieldKeys.forEach(function (key) {
      var value = getFieldValue(fields[key]);

      if (!value) {
        missing.push(key);
      } else if (!isValidCustomDimensionValue(value)) {
        invalid.push(key);
      }
    });

    return {
      fields: fields,
      hasAnyValue: hasAnyValue,
      hasCustomRadio: hasCustomRadio,
      missing: missing,
      invalid: invalid,
      isCustomMode: hasAnyValue || hasCustomRadio,
      isComplete: missing.length === 0 && invalid.length === 0
    };
  }

  function getOrCreateErrorElement(picker) {
    var error = picker.querySelector('[data-custom-dimensions-error]');
    if (error) return error;

    var customize = picker.querySelector('.custom-dimensions-picker__customize');
    if (!customize) return null;

    error = document.createElement('p');
    error.className = 'custom-dimensions-picker__error';
    error.setAttribute('data-custom-dimensions-error', 'true');
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'polite');
    error.hidden = true;
    error.textContent = 'Please enter Length, Width, and Height for custom dimensions.';

    customize.appendChild(error);
    return error;
  }

  function updateCustomDimensionValidation() {
    qsa(document, '[data-custom-dimensions-picker]').forEach(function (picker) {
      var state = getPickerCustomState(picker);
      var showError = state.isCustomMode && !state.isComplete;
      var error = getOrCreateErrorElement(picker);

      picker.classList.toggle('custom-dimensions-picker--has-error', showError);

      if (error) {
        error.hidden = !showError;
        error.classList.toggle('is-active', showError);
        error.setAttribute('data-error-active', String(showError));
      }

      Object.keys(state.fields).forEach(function (key) {
        var field = state.fields[key];
        var invalid = showError && (
          state.missing.indexOf(key) !== -1 ||
          state.invalid.indexOf(key) !== -1
        );

        if (!field) return;

        field.classList.toggle('is-custom-dimension-invalid', invalid);

        if (invalid) {
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.removeAttribute('aria-invalid');
        }
      });
    });
  }

  function updateAddToCartVisibility(forceShow) {
    ensureStyle();
    updateCustomDimensionValidation();

    var hide = forceShow ? false : shouldHideAddToCart();

    getAddToCartButtons().forEach(function (button) {
      if (!button || !button.classList) return;

      button.setAttribute('data-custom-atc-hidden-state', String(hide));

      if (hide) {
        button.classList.add('is-custom-value-add-hidden');
        button.classList.add('hidden');
        button.setAttribute('aria-hidden', 'true');
        button.style.display = 'none';

        if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
          if (!button.disabled) button.setAttribute('data-custom-disabled-by-script', 'true');
          button.disabled = true;
        }
      } else {
        button.classList.remove('is-custom-value-add-hidden');
        button.classList.remove('hidden');
        button.classList.remove('is-hidden');
        button.removeAttribute('hidden');
        button.removeAttribute('aria-hidden');
        button.style.display = '';

        if (button.getAttribute('data-custom-disabled-by-script') === 'true') {
          button.disabled = false;
          button.removeAttribute('data-custom-disabled-by-script');
        }
      }
    });
  }

  function scheduleUpdate(forceShow, delay) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      updateAddToCartVisibility(forceShow);
    }, typeof delay === 'number' ? delay : 40);
  }

  function clearForceShowTimer() {
    if (forceShowTimer) {
      window.clearTimeout(forceShowTimer);
      forceShowTimer = null;
    }
  }

  function getSelectableControl(target) {
    if (!target) return null;
    if (isInsideCustomDimensionTextArea(target)) return null;

    var control = closest(target, 'input[type="radio"], input[type="checkbox"], select');
    if (control) return control;

    var label = closest(target, 'label');

    if (label) {
      if (label.htmlFor) {
        var byId = document.getElementById(label.htmlFor);

        if (byId && byId.matches('input[type="radio"], input[type="checkbox"], select')) {
          return byId;
        }
      }

      var inside = label.querySelector('input[type="radio"], input[type="checkbox"], select');
      if (inside) return inside;
    }

    var optionItem = closest(
      target,
      '.block-standard-option__item, ' +
        '.block-addon-option__item, ' +
        '.block-color-texture-card__color-item, ' +
        '.block-color-texture-card__texture-item, ' +
        '.block-standard-option__label, ' +
        '.block-addon-option__label, ' +
        '.block-color-texture-card__color-label, ' +
        '.block-color-texture-card__texture-label, ' +
        '.custom-dimensions-picker__radio'
    );

    return optionItem ? optionItem.querySelector('input[type="radio"], input[type="checkbox"], select') : null;
  }

  function isNormalSelectableControl(control) {
    if (!control) return false;
    if (isQuoteCustomControl(control)) return false;

    if (control.getAttribute('data-store-only-property') === 'true') return false;
    if (control.getAttribute('data-custom-dimension-radio') === 'true') return false;
    if (isInsideCustomDimensionTextArea(control)) return false;

    return !!closest(
      control,
      '.block-standard-option, ' +
        '.block-color-texture-card, ' +
        '.custom-dimensions-picker, ' +
        '[data-standard-options]'
    );
  }

  function isSingleColorTextureChoice(input) {
    var card = closest(input, '[data-color-texture-card]');
    if (!card) return false;

    var options = qsa(card, '.block-color-texture-card__color-fieldset input[type="radio"]').filter(function (optionInput) {
      if (!optionInput || optionInput.disabled || optionInput.matches('[data-decide-later-input="true"]')) return false;

      var option = closest(optionInput, '.block-color-texture-card__color-item');
      if (!option) return true;

      return !option.hidden && option.style.display !== 'none';
    });

    return options.length === 1 && options[0] === input;
  }

  function clearQuoteCustomOptions(exceptControl) {
    qsa(
      document,
      '.block-addon-group--quote input:checked, ' +
        '[data-custom-modification-options] input:checked, ' +
        '[data-option-group="quote-only"] input:checked, ' +
        'input[data-quote-only="true"]:checked, ' +
        'input[data-is-custom-option="true"]:checked'
    ).forEach(function (input) {
      if (!input || input === exceptControl) return;
      if (input.getAttribute('data-default-enabled-option') === 'true') return;
      if (isSingleColorTextureChoice(input)) return;
      if (!isQuoteCustomControl(input)) return;

      input.checked = false;
      input.removeAttribute('checked');
      input.removeAttribute('data-was-checked-before-click');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function clearCustomDimensionFields() {
    isProgrammaticClear = true;

    window.dispatchEvent(new CustomEvent('custom-dimensions:clear'));
    document.dispatchEvent(new CustomEvent('custom-dimensions:clear'));

    getCustomDimensionFields(document).forEach(function (field) {
      var type = (field.getAttribute('type') || '').toLowerCase();

      if (type === 'radio' || type === 'checkbox') {
        field.checked = false;
        field.removeAttribute('checked');
      } else if (field.tagName === 'SELECT') {
        field.selectedIndex = -1;
        field.value = '';
      } else {
        field.value = '';

        try {
          field.defaultValue = '';
        } catch (e) {}

        field.removeAttribute('value');
      }
    });

    qsa(document, '[data-custom-dimension-radio="true"]').forEach(function (radio) {
      radio.checked = false;
      radio.removeAttribute('checked');
    });

    try {
      window.CustomDimensionsSavedValues = {};
      window.CustomDimensionsAutoSelectedKeys = {};
      window.CustomDimensionsClearRequested = true;

      window.clearTimeout(window.CustomDimensionsReleaseClearTimer);

      window.CustomDimensionsReleaseClearTimer = window.setTimeout(function () {
        window.CustomDimensionsClearRequested = false;
      }, 800);
    } catch (e) {}

    window.setTimeout(function () {
      updateCustomDimensionValidation();
      isProgrammaticClear = false;
      updateAddToCartVisibility(false);
    }, 80);
  }

  function handleQuoteCustomSelection() {
    clearForceShowTimer();
    scheduleUpdate(false, 140);
  }

  function isDimensionPresetControl(control) {
    if (!control || !closest(control, '[data-custom-dimensions-picker]')) return false;
    if (control.getAttribute('data-custom-dimension-radio') === 'true') return false;
    if (isInsideCustomDimensionTextArea(control)) return false;

    return !!closest(control, '[data-dimension-option]');
  }

  function handleNormalSelection(control) {
    clearForceShowTimer();

    if (isDimensionPresetControl(control)) {
      clearCustomDimensionFields();
    }

    scheduleUpdate(false, 160);
  }

  function handleControlEvent(target) {
    var control = getSelectableControl(target);

    if (!control) {
      scheduleUpdate(false, 40);
      return;
    }

    if (isQuoteCustomControl(control)) {
      handleQuoteCustomSelection();
      return;
    }

    if (isNormalSelectableControl(control)) {
      handleNormalSelection(control);
      return;
    }

    scheduleUpdate(false, 40);
  }

  function handleCustomFieldEvent() {
    if (isProgrammaticClear) return;

    clearForceShowTimer();
    scheduleUpdate(false, 120);
  }

  document.addEventListener(
    'click',
    function (event) {
      var isAtcClick = getAddToCartButtons().some(function(btn) {
        return btn === event.target || btn.contains(event.target);
      });

      if (isAtcClick && shouldHideAddToCart()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (isInsideCustomDimensionTextArea(event.target)) {
        handleCustomFieldEvent();
        return;
      }

      window.setTimeout(function () {
        handleControlEvent(event.target);
      }, 0);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var target = event.target;
      if (target && target.tagName === 'FORM' && (target.action || '').indexOf('/cart/add') !== -1) {
        if (shouldHideAddToCart()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (isProgrammaticClear) return;

      if (isInsideCustomDimensionTextArea(event.target)) {
        handleCustomFieldEvent();
        return;
      }

      handleControlEvent(event.target);
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      if (isProgrammaticClear) return;

      if (isInsideCustomDimensionTextArea(event.target)) {
        handleCustomFieldEvent();
      }
    },
    true
  );

  document.addEventListener(
    'focusout',
    function (event) {
      if (isProgrammaticClear) return;

      if (isInsideCustomDimensionTextArea(event.target)) {
        window.setTimeout(function () {
          updateAddToCartVisibility(false);
        }, 30);

        window.setTimeout(function () {
          updateAddToCartVisibility(false);
        }, 180);
      }
    },
    true
  );

  function init() {
    ensureStyle();
    updateAddToCartVisibility(false);

    window.setTimeout(function () {
      updateAddToCartVisibility(false);
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', init);
  document.addEventListener('product:variant-change', init);

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init();
  }
})();
}
